(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xtra-rental-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('xtra-rental-gallery')) {
    customElements.define('xtra-rental-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-xrp-thumb]');
          if (!button || !this.contains(button)) return;
          const index = button.dataset.xrpThumb;
          this.querySelectorAll('[data-xrp-slide]').forEach((slide) => {
            slide.hidden = slide.dataset.xrpSlide !== index;
          });
          this.querySelectorAll('[data-xrp-thumb]').forEach((thumb) => {
            thumb.setAttribute('aria-pressed', String(thumb === button));
          });
          this.querySelector('[data-xrp-current]').textContent = index;
        }, { signal:this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
